import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip
} from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const plans = [
  {
    name: 'Basic',
    tier: 'basic',
    price: 'Free',
    features: [
      'Up to 10 searches per day',
      'Basic arbitrage scoring',
      'View vehicle details',
    ],
  },
  {
    name: 'Pro',
    tier: 'pro',
    price: '$19/mo',
    features: [
      'Unlimited searches',
      'Advanced arbitrage scoring',
      'Saved searches & alerts',
      'Market trend analysis',
      'Priority support',
    ],
  },
  {
    name: 'Enterprise',
    tier: 'enterprise',
    price: '$49/mo',
    features: [
      'Everything in Pro',
      'API access',
      'Bulk vehicle analysis',
      'Custom alerts & notifications',
      'Dedicated support',
    ],
  },
];

function Subscription() {
  const { userData } = useAuth();
  const currentTier = userData?.subscription_tier || 'basic';

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Subscription Plans
      </Typography>
      <Typography variant="body1" color="text.secondary" gutterBottom>
        Choose the plan that fits your needs.
      </Typography>

      <Grid container spacing={3} sx={{ mt: 1 }}>
        {plans.map((plan) => (
          <Grid item xs={12} md={4} key={plan.tier}>
            <Paper
              sx={{
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                border: currentTier === plan.tier ? 2 : 0,
                borderColor: 'primary.main',
              }}
              elevation={currentTier === plan.tier ? 6 : 1}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="h5" fontWeight="bold">
                  {plan.name}
                </Typography>
                {currentTier === plan.tier && (
                  <Chip label="Current" color="primary" size="small" />
                )}
              </Box>
              <Typography variant="h4" color="primary" gutterBottom>
                {plan.price}
              </Typography>

              <List dense sx={{ flexGrow: 1 }}>
                {plan.features.map((feature) => (
                  <ListItem key={feature} disableGutters>
                    <ListItemIcon sx={{ minWidth: 32 }}>
                      <CheckIcon color="success" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary={feature} />
                  </ListItem>
                ))}
              </List>

              <Button
                variant={currentTier === plan.tier ? 'outlined' : 'contained'}
                fullWidth
                disabled={currentTier === plan.tier}
                sx={{ mt: 2 }}
              >
                {currentTier === plan.tier ? 'Current Plan' : 'Upgrade'}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Subscription;
